import {Group} from "react-konva";
import {gridToImage} from "@/dungeons/geometry/Coordinates.ts";
import type {LevelGeometryDocument} from "@/dungeons/model/DungeonGeometry.ts";
import type {GeometrySnapResult} from "./GeometrySnapping.ts";
import GeometrySnapMarker from "./GeometrySnapMarker.tsx";

export default function GeometrySnapPreviewOverlay({geometry, snap, zoom}: {
    geometry: LevelGeometryDocument;
    snap?: GeometrySnapResult;
    zoom: number;
}) {
    return <Group listening={false}>{snap && <GeometrySnapMarker
        point={gridToImage(snap.point, geometry.registration)} target={snap.target} zoom={zoom}/>}</Group>;
}
